import { Role } from '@ps20/bff-models';

export interface StateWithTransientState {
  transientState: Rolle;
}

export interface Rolle {
  role: Role;
}

export interface VorvertragVorschaedenState {
  vorvertragVorschaeden?: number;
}

export interface TransientStateWithRegexps {
  transientState: {
    regexps: {
      [key: string]: string;
    };
  };
}

export enum PersonensucheModal {
  UNFALL = 'UNFALL',
  FREMDVERTRAG = 'FREMDVERTRAG',
  CLOSED = 'CLOSED',
  KONTO_INHABER = 'KONTO_INHABER',
  BEZUGSRECHT = 'BEZUGSRECHT',
}
